import { create } from 'zustand'
import { Visualization } from '~map-preview/types/__generated/gql/graphql'

interface MapSettingsState {
  defaultVisualization: Visualization
  setDefaultVisualization: (data: Visualization) => void
}

export const useMapSettingsStore = create<MapSettingsState>((set) => ({
  defaultVisualization: {
    marker: {
      id: 'marker',
      type: 'marker'
    }
  },

  // Set the active map layer
  setDefaultVisualization: (data) => set(() => ({ defaultVisualization: data }))
}))
